<script lang="ts">

    /**
     * Quatity input field
    */
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    /**
     * quantity
     */
    export let quantity;

    export let label = "Qté"

    /**
     * dispatch quantity
     */
    function updateQuantity(): void {
        dispatch("update-quantity", quantity);
    }

    /**
     * increment/decrement quantity
     * @param incre
     */
    function incrementQTE(incre: number): void {
        quantity += incre;
        dispatch("update-quantity", quantity);
    }
</script>

<div class="input-qte">
    <label for="qte"> {label}: </label>
    <input type="number" bind:value={quantity} on:change={updateQuantity} />
    <div class="change-qte-buttons">
        <span class="icon is-clickable" on:click={() => incrementQTE(1)}>
            <i class="fas fa-chevron-up" />
        </span>
        <span class="icon is-clickable" on:click={() => incrementQTE(-1)}>
            <i class="fas fa-chevron-down" />
        </span>
    </div>
</div>

<style lang="scss">
    .input-qte {
        display: flex;
        flex-direction: row;
        width: 100%;
        gap: 10px;
        align-items: center;
        input {
            width: 50px;
        }
        .change-qte-buttons {
            display: flex;
            flex-direction: column;
        }
    }
</style>
